import './TicketLogisticStateTag.scss';

import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';

import { TICKET_LOGISTIC_STATE, TicketLogisticStateString } from '@/model/Ticket/TicketConstants';

interface TicketLogisticStateTagProps {
  ticketLogisticState: TICKET_LOGISTIC_STATE;
}

const TicketLogisticStateTag = (props: TicketLogisticStateTagProps) => {
  const { t } = useTranslation();
  const { ticketLogisticState } = props;

  return (
    <Tag className={'TicketLogisticStateTag ' + TICKET_LOGISTIC_STATE[ticketLogisticState]}>
      {t(TicketLogisticStateString[ticketLogisticState])}
    </Tag>
  );
};

export default TicketLogisticStateTag;
